export const filters = {
  translate: (data, field, lang) => {
    return data[field + "_" + lang];
  },
  date: function(date) {
    let d = new Date(date);
    return (
      d.getDate() + "/" + (parseInt(d.getMonth()) + 1) + "/" + d.getFullYear()
    );
  },
  hour: function(hour) {
    let d = new Date(hour);
    let mins = d.getMinutes();
    if (mins < 10) {
      mins = "0" + mins;
    }
    return d.getHours() + ":" + mins;
  },
  boolean: function(data) {
    switch (data) {
      case 1:
        return "Si";
        break;
      default:
        return "No";
        break;
    }
  },
  singleSelection: function(data) {
    let option = JSON.parse(data.data);
    let opts = JSON.parse(data.options);
    let response = "";
    let opt = opts.filter(o => o.id === option);
    let info = "";
    if (opt[0].info) {
      info = opt[0].info;
    }
    response = opt[0].text + " " + info;

    return response;
  },
  multipleOptions: function(data, opts) {
    let options = JSON.parse(data);
    opts = JSON.parse(opts);
    let response = "";
    let opt = null;
    let info = "";
    options.forEach(option => {
      opt = opts.filter(element => element.id === option);
      if (opt[0].info) {
        info = ":" + opt[0].info;
      }
      response += opt[0].text + info + ", ";
    });
    response = response.replace(/([\s\,]+)$/gm, "");
    return response;
  },
  multipleNumeric: function(src) {
    let data = JSON.parse(src.data);
    let opts = JSON.parse(src.options);
    let response = "";
    opts.forEach((option, index) => {
      let info = "";
      if (option.info) {
        info = " " + option.info;
      }
      response += option.text + info + ": " + data[index] + "<br>";
    });
    return response;
  },
  noQuotes: function(text) {
    let txt = text.replace(/(^[\"]+)|([\"]+)$/gm, "");
    return txt;
  },
  price: function(amount, options = { currency: "MXN", lang: "es-MX" }) {
    let num = parseFloat(amount);
    return (
      num.toLocaleString(options.lang, {
        style: "currency",
        currency: options.currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) +
      " " +
      options.currency
    );
  },
  longDate: function(date, lang) {
    let dateString = "";
    if (date) {
      let d = new Date(date);
      dateString = d.toLocaleDateString(lang, {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric"
      });
    }
    return dateString;
  }
};


// WEBPACK FOOTER //
// ./src/core/libs/filters.js